import { useState } from 'react';

import { emailLogin,signUpWithOnlyEmail } from 'services/authService';
import { addUserGroupToData } from 'utils';
import { SIGN_UP_STATUSES } from 'utils/constant';

export const useSignUp = () => {
  const [error, setError] = useState('');

  /**
   * Sign up user with email only
   *
   * @param {Object} data
   * @param {Function} callback
   */
  const withEmail = async (data, callback) => {
    addUserGroupToData(data);

    try {
      const response = await signUpWithOnlyEmail(data);

      let status = SIGN_UP_STATUSES.ERROR;

      if (response === 'userAlreadyExist') {
        status = SIGN_UP_STATUSES.EXIST;
      } else if (response?.success) {
        status = SIGN_UP_STATUSES.SUCCESS;
      } else if (response?.userValidationError) {
        setError(response?.userValidationError);
      } else {
        console.error('Not able to login using email', response);
      }

      callback(response, status);
    } catch (error) {
      if (error?.userValidationError) {
        setError(error?.userValidationError);
      } else {
        console.error('Error occurred while signup with email', error);
      }
    }
  };

  const withSignIn = async (data, callback) => {
    try {
      await emailLogin(data);
      callback();
    } catch (err) {
      const { result = {} } = err;
      const { userValidationError } = result || {};
      setError(userValidationError);
    }
  };

  return {
    withEmail,
    withSignIn,
    setError,
    error,
  };
};
